<template>

  <div class="user">
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <el-form-item label="是否开启" prop="is_coupon">
        <el-switch v-model="form.status"></el-switch>
      </el-form-item>


      <el-form-item label="任务主页bannar" prop="describe">
        <div v-if="form.logo.file_path" class="default-image-box" @click="isAboutLogoUpload = true">
          <div class="image-box">
            <img :src="form.logo.file_path" alt="product_default_image">
            <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteLogoImg">
              <i class="el-icon-close"></i>
            </a>
          </div>
        </div>
        <div v-else>
          <div class="img-select" @click="isAboutLogoUpload = true"><i class="el-icon-plus"></i></div>
        </div>
      </el-form-item>


      <el-form-item label="分类"  >
        <el-button size="small" type="primary" @click="addCategory" >新增分类</el-button>
        <el-table :data="form.category" border size="mini" style="width: 100%;margin-top: 20px;">
          <el-table-column prop="id" label="编号" width="200">
              <template v-slot="scope">
                <div class="d-s-c">
                  {{ scope.row.id }}
                </div>
              </template>

            </el-table-column>
          
          <el-table-column prop="name" label="分类名称" width="250">
              <template v-slot="scope">
                <div class="d-s-c">
                  <el-input style="width: 200px;" v-model="scope.row.name"  placeholder="请输入分类名称"></el-input>
                </div>
              </template>

            </el-table-column>


            <el-table-column prop="sort" label="排序" width="250">
              <template v-slot="scope">
                <div class="d-s-c">
                  <el-input style="width: 200px;" v-model="scope.row.sort"  placeholder="请输入排序"></el-input>
                </div>
              </template>

            </el-table-column>
                 
  

            <el-table-column prop="name" label="操作"  width="100">
              <template v-slot="scope">
                <div style="color: blue;" @click="delCategory(scope.$index)">删除</div>

              </template>
            </el-table-column>
          </el-table>
      </el-form-item>





    </el-form>

    
    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">保存</el-button>
    </div>

    <!--商品图片组件-->
    <!-- <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload> -->
    <!-- logo图片组件 -->
    <Upload v-if="isAboutLogoUpload" :config="{ total: 9 }" :isupload="isAboutLogoUpload" @returnImgs="returnLogoImgsFunc">上传图片</Upload>

 </div>
</template>
<script>
import DotaskApi from '@/api/dotask.js';
import Upload from '@/components/file/Upload';
import draggable from 'vuedraggable';

export default {
  components: {
    Upload,
    draggable
  },
  data() {
    return {
      form: {
        status: false,
        logo: {
          file_id: '',
          file_path: ''
        },
        category:[]

      },
      setting: [],
      loading: false,
      isProductUpload:false,
      isAboutLogoUpload:false,
      
    };
  },
  created() {
    /*获取列表*/
    this.getSetting();
  },
  methods: {
    addCategory(){
      this.form.category.push({
        "id": this.form.category.length>=1?  this.form.category[this.form.category.length-1].id+1 :1,
        "name":"",
        "val":0,
        "sort":1,
        
      });
    },
    delCategory(idex){
      this.form.category.splice(idex,1)
    },
    /*获取设置*/
    getSetting() {
      let self = this;
      let Params = {};
      DotaskApi.getSetting(Params, true)
        .then(data => {
          self.loading = false;
          console.log(data)
          if(data.data.vars.values!='[]'){
            self.form = data.data.vars.values;
          }
          if(!this.form.category){
            this.form.category = [];
          }
          if(self.form.logo && self.form.logo.file_path){
           
          }else{
            self.form.logo = {
              file_path:""
            }
          }
          
        })
        .catch(error => {});
    },
    /*点击保存*/
    onSubmit() {
      let self = this;
      let params = self.form;
      self.loading = true;
      DotaskApi.saveSetting(params, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.$message({
              message: '恭喜你，保存成功',
              type: 'success'
            });
            self.getSetting();
          } else {
            self.loading = false;
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },
        // 删除logo图片
        deleteLogoImg() {
      this.form.logo = {
        file_id: '',
        file_path: ''
      }
    },
       // 上传logo图片
       returnLogoImgsFunc(e) {
      if (e != null) {
        let imgExpt = ['bmp', 'jpg', 'jpeg', 'png', 'gif']
        let prevent = false
        e.forEach((element) => {
          let data_array = element.file_path.split('.')
          let ext = data_array[data_array.length - 1]
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          })
        })
        if (!prevent) {
          this.$message.error('图片类型有误,请选择正确的图片格式')
          return false
        }
        this.form.logo.file_id = e[0].file_id
        this.form.logo.file_path = e[0].file_path
      }
      this.isAboutLogoUpload = false
    },

  }
};
</script>

<style>
.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}

.img-select {
  position: relative;
  width: 110px;
  height: 110px;
  margin-right: 10px;

  i {
    display: flex;
    line-height: 110px;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    border: 1px dashed #dddddd;
    font-size: 30px;
    color: #409eff;
  }
}

.image-box {
  width: 110px;
  height: 110px;
  overflow: hidden;

  img {
    width: 110px;
    //height: 110px;
  }
}

.image-box:hover .delete-btn {
  display: block;
}

.default-image-box {
  position: relative;
  width: 110px;
  height: 110px;
}

.delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/dotask/setting/getSetting.vue